import * as types from './eventTypes';

export default function pushToOTM(type, data) {
  const otmFeed = window?.otm_feed || [];
  if (otmFeed) {
    try {
      switch (type) {
        case types.EVENT_ADD_TO_CART:
        case types.EVENT_COMMON_ADD_TO_CART:
        case types.EVENT_PRODUCT_ADD_TO_CART: {
          otmFeed.push({
            event: 'cart',
            items: [data?.productId || data?.id],
          });
          break;
        }
        case types.EVENT_LOAD_DETAILS: {
          otmFeed.push({
            event: 'view',
            items: [data?.id || data?.productId],
          });
          break;
        }
        default:
          return false;
      }
    } catch (e) {
      console.warn(`An error occurred while trying to push '${type}' to OTM`);
      throw new Error(e);
    }
  }
  return true;
}
